import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  watch,
} from 'vue';

// Components
import {
  Checkbox,
  ExpandableContent
} from 'ui-shared-components';

import IconTick from '@white-label-icon/icon-tick';
import IconButton from '@white-label-icon/icon-button';
import IconLink from '@white-label-icon/icon-link';

// Helpers
import { formatPrice } from '@white-label-helper/helper-payment';

interface AddOn {
  name: string;
  price: number;
  selected: boolean;
  details?: string;
}

interface AddOnWithExpanded extends AddOn {
  expanded: boolean;
}

interface Policy {
  document: string;
  features: string[];
  addOns: AddOn[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-policy',
  props: {
    policy: { default: null },
    loading: { type: Boolean, default: false }
  },
  emits: ['addOnSelect'],
  setup(__props: any, { emit }) {

const props = __props as { policy: Policy | null, loading: boolean };





const skeletonItemsCount = 7;
const skeletonAddonsCount = 3;
const addOns = ref<AddOnWithExpanded[]>(
  props.policy?.addOns?.map((addOn) => ({ ...addOn, expanded: false })) || []
);

watch(
  () => props.policy,
  (newPolicy) => {
    addOns.value = newPolicy?.addOns?.map((addOn) => ({ ...addOn, expanded: false })) || [];
  },
  { deep: true },
);

function handleAddOnSelect(addOn?: AddOnWithExpanded) {
  if (addOn) {
    addOn.selected = !addOn.selected;
  }
  emit('addOnSelect', addOns.value);
}

return { __sfc: true,props, emit, skeletonItemsCount, skeletonAddonsCount, addOns, handleAddOnSelect, Checkbox, ExpandableContent, IconTick, IconButton, IconLink, formatPrice }
}

})